import React, { useEffect, useState } from 'react';

import moment from 'moment';

import { getModeEvents, getDayTimeSteps, getModeDays } from '../../helpers/calendar-data-helper';
import * as calendarConsts from '../../constants/calendar-constants';

import CustomEventWrapper from './day-mode/custom-events-wrapper';

import './day-mode/custom-sizes.less';
import CardEvent from './custom-events/card-event';

const CalendarCustomMode = (props) => {
  const {
    calendarEvents,
    currentDate,
    dateFrom,
    onAddEvent,
    onEditEvent,
    onDeleteEvent,
    eventLoading,
    rootContainer,
    customMode,
    calendarCategories,
    settings,
    onToggleEvents,
  } = props;

  const [dayShortEvents, setDayShortEvents] = useState([]);
  const [headEvents, setHeadEvents] = useState([]);
  const [mode, setMode] = useState(null);
  const timeSteps = getDayTimeSteps();
  const [modeDays, setModeDays] = useState([]);

  useEffect(() => {
    if (currentDate && dateFrom && customMode) {
      const mainDates = {
        navigationDate: currentDate,
        dateFrom: dateFrom,
      };

      setMode(customMode);

      const modeDayArray = getModeDays(mainDates, customMode);
      setModeDays(modeDayArray);
    }
  }, [currentDate, dateFrom, customMode]);

  useEffect(() => {
    if (calendarEvents && modeDays && mode) {
      const allEvents = getModeEvents(modeDays, calendarEvents, mode);

      if (allEvents) {
        setHeadEvents(allEvents.headEvents);
        setDayShortEvents(allEvents.dayShortEvents);
      }
    }
  }, [calendarEvents, modeDays, mode]);

  const handleAddEventClick = (domEvent, momentDateStart, mins) => {
    const momentDateObj = momentDateStart.clone().add(mins, 'minutes');

    if (typeof onAddEvent == 'function') {
      onAddEvent(domEvent, momentDateObj, true, calendarConsts.CustomModeTimeStep);
    }
  };

  return (
    <CustomEventWrapper
      loading={eventLoading}
      rootContainer={rootContainer}
      headEvents={headEvents}
      onEditEvent={onEditEvent}
      onDeleteEvent={onDeleteEvent}
      onAddEvent={handleAddEventClick}
      timeSteps={timeSteps}
      days={modeDays}
      calendarCategories={calendarCategories}
      settings={settings}
      onToggleEvents={onToggleEvents}
    >
      {dayShortEvents &&
        dayShortEvents.map((dayObj) => {
          let mainColumnClass = '';
          if (dayShortEvents.length === calendarConsts.WeekModeDays) {
            mainColumnClass = 'week-column';
          } else if (dayShortEvents.length === calendarConsts.DayModeDays) {
            mainColumnClass = 'single-column';
          } else if (dayShortEvents.length === calendarConsts.TimelineModeDays) {
            mainColumnClass = 'timeline-column';
          }

          return (
            <div key={dayObj.dateKey} className={['custom-mode-day-event-content', mainColumnClass].join(' ')}>
              {dayObj.dayEvents.map((eventItem) => {
                return eventItem.positions ? (
                  <CardEvent
                    key={eventItem.cellKey}
                    eventItem={eventItem}
                    onEditEvent={onEditEvent}
                    onDeleteEvent={onDeleteEvent}
                    rootContainer={rootContainer}
                    calendarCategories={calendarCategories}
                  />
                ) : null;
              })}

              <div key={mode + '-day-' + dayObj.dateKey} className={'event-time-line-column right-bordered'}>
                {timeSteps.map((el) => {
                  return (
                    <div
                      key={mode + '-day-' + dayObj.dateKey + '-line-' + el.key}
                      title={'Click to add event at ' + dayObj.dateKey + ' ' + el.val}
                      className="event-time-line bottom-bordered time-step"
                      onClick={($event) => handleAddEventClick($event, dayObj.dateObjStart, el.mins)}
                    ></div>
                  );
                })}
              </div>
            </div>
          );
        })}
    </CustomEventWrapper>
  );
};

export default CalendarCustomMode;
